import { useState, useEffect } from 'react';
import { assemblyService, propertyService } from 'services/api';
import PropertyCombobox from 'components/PropertyCombobox';
import { useAuth } from 'context/AuthContext';
import AssemblyReport from 'components/AssemblyReport';
import Paginacion from 'components/Paginacion';
import styles from './ActasReportes.module.css';

const PAGE_SIZE = 25;

const fmtFecha = (d) => d ? new Date(d).toLocaleDateString('es-CO', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

export default function ActasReportes() {
  const { isSuperAdmin, user } = useAuth();
  const isAdminMultiProp = user?.role === 'admin';

  const [assemblies, setAssemblies] = useState([]);
  const [loading,    setLoading]    = useState(true);
  const [page,       setPage]       = useState(1);
  const [total,      setTotal]      = useState(0);

  // Selector de propiedad — mismo patrón que Asambleas/Unidades
  const [properties, setProperties] = useState([]);
  const [filterProp, setFilterProp] = useState('');

  useEffect(() => {
    if (isSuperAdmin || isAdminMultiProp) {
      propertyService.selector({ limit: 200 }).then(r => {
        const props = r.data.data || [];
        setProperties(props);
        if (isAdminMultiProp && !isSuperAdmin && props.length === 1) setFilterProp(String(props[0].id));
      });
    }
  }, [isSuperAdmin, isAdminMultiProp]);

  // Paginación en el servidor: antes se pedían 200 y las demás asambleas no aparecían, sin aviso.
  useEffect(() => {
    let vigente = true;
    setLoading(true);
    assemblyService.getAll({ page, limit: PAGE_SIZE, ...(filterProp ? { property_id: filterProp } : {}) })
      .then(r => { if (vigente) { setAssemblies(r.data.data || []); setTotal(r.data.total || 0); } })
      .finally(() => { if (vigente) setLoading(false); });
    return () => { vigente = false; };
  }, [page, filterProp]);

  const cambiarPropiedad = (id) => { setFilterProp(id); setPage(1); };
  const irAPagina = (n) => { setPage(n); window.scrollTo({ top: 0 }); };

  return (
    <div>
      <div className="page-header">
        <div>
          <h1><i className={`fas fa-file-pdf ${styles.iconoCabecera}`} />Actas de asamblea</h1>
          <p>Genera y descarga el acta PDF de cualquier asamblea</p>
        </div>
        <div className={styles.acciones}>
          {(isSuperAdmin || (isAdminMultiProp && properties.length > 1)) && (
            <div className={styles.filtro}>
              <i className={`fas fa-building ${styles.iconoFiltro}`} />
              <PropertyCombobox value={filterProp} onChange={cambiarPropiedad} placeholder="Todas las propiedades" />
              {filterProp && <button className="btn btn-sm btn-secondary btn-icon" onClick={() => cambiarPropiedad('')} title="Limpiar">
                <i className="fas fa-times" /></button>}
            </div>
          )}
        </div>
      </div>

      <div className="card">
        <div className={`card-body ${styles.sinRelleno}`}>
          {loading ? <div className="loading"><div className="spinner" /></div> :
            !assemblies.length ? (
              <div className="empty-state">
                <i className="fas fa-gavel" />
                <p>{filterProp ? 'No hay asambleas registradas para esta propiedad.' : 'No hay asambleas registradas todavía.'}</p>
              </div>
            ) : (
              <div className="table-wrapper">
                <table>
                  <thead>
                    <tr><th>Propiedad</th><th>N° Asamblea</th><th>Tipo</th><th>Fecha</th><th>Estado</th><th>Acta</th></tr>
                  </thead>
                  <tbody>
                    {assemblies.map(a => (
                      <tr key={a.id}>
                        <td>{a.property?.name || '—'}</td>
                        <td>#{a.number_assembly}</td>
                        <td className={styles.tipo}>{a.assembly_type || '—'}</td>
                        <td>{fmtFecha(a.date)}</td>
                        <td><span className="badge badge-secondary">{a.status}</span></td>
                        <td><AssemblyReport assemblyId={a.id} compact /></td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
        </div>
      </div>
      {!loading && <Paginacion pagina={page} total={total} porPagina={PAGE_SIZE} onCambiar={irAPagina} />}
    </div>
  );
}
